import React from "react";
import AboutText from "../assets/data/aboutText.json";
import ACTLogo from "../assets/images/ACT-logo-with-text.png";
import { Box, Typography } from "@mui/material";
import Footer from "./Footer";

const About = () => {
  const goToACT = () => {
    window.open("#", "_blank");
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          minHeight: "95vh",
          width: "100vw",
          marginBottom: "1rem",
        }}
      >
        <Box
          sx={{
            width: "80vw",
            maxWidth: "600px",
            marginTop: "6rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "3.5rem",
            }}
          >
            <img
              src={ACTLogo}
              alt="ACT Logo"
              style={{
                imageRendering: "crisp-edges",
                height: "7rem",
                width: "auto",
              }}
            />
          </Box>

          {AboutText.paragraphs.map((paragraph, index) => (
            <Typography
              sx={{
                fontSize: "0.875rem",
                lineHeight: "1.5",
                marginBottom: "1rem",
              }}
              key={index}
            >
              {paragraph.text}
            </Typography>
          ))}
          <Typography
            onClick={goToACT}
            sx={{
              fontSize: "0.875rem",
              lineHeight: "1.5",
              marginTop: "4rem",
              cursor: "pointer",
              textDecoration: "underline",
              "&:hover": {
                opacity: "0.6",
              },
            }}
          >
            www.advancedcompliance.tech/actverify
          </Typography>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default About;
